import React, { useState } from 'react';
import Footer from '../Components/Footer';
import Navbar from '../Components/Navbar';
import '../Styles/Work.css';

function BookACall() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    time: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to your backend
    console.log('Form submitted:', formData);
    
    // For demo purposes, we'll just show a success message
    setIsSubmitted(true);
    
    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      date: '',
      time: '',
      message: ''
    });
    
    // Hide success message after 5 seconds
    setTimeout(() => setIsSubmitted(false), 5000);
  };

  return (
    <>
      <Navbar />
      <div className='banner banner2'>
        <h2>Book a Call</h2>
        <p>Home / Work With Us / Book a Call</p>
      </div>
      
      <div className='work-container'>
        <div className='contact-form' data-aos="fade-up">
          <h2 className='text-center mb-4'>Schedule a Consultation</h2>
          <p className='text-center mb-5'>
            Fill out the form below to schedule a call with our team. We'll get back to you shortly to confirm your appointment.
          </p>
          
          {isSubmitted && (
            <div className="alert alert-success" role="alert">
              Thank you for your request! We'll contact you soon to confirm your appointment.
            </div>
          )}
          
          <form onSubmit={handleSubmit}>
            <div className='form-group'>
              <label htmlFor='name'>Full Name *</label>
              <input
                type='text'
                id='name'
                name='name'
                className='form-control'
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className='row'>
              <div className='col-md-6'>
                <div className='form-group'>
                  <label htmlFor='email'>Email Address *</label>
                  <input
                    type='email'
                    id='email'
                    name='email'
                    className='form-control'
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className='col-md-6'>
                <div className='form-group'>
                  <label htmlFor='phone'>Phone Number</label>
                  <input
                    type='tel'
                    id='phone'
                    name='phone'
                    className='form-control'
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            
            <div className='row'>
              <div className='col-md-6'>
                <div className='form-group'>
                  <label htmlFor='date'>Preferred Date *</label>
                  <input
                    type='date'
                    id='date'
                    name='date'
                    className='form-control'
                    value={formData.date}
                    onChange={handleChange}
                    min={new Date().toISOString().split('T')[0]}
                    required
                  />
                </div>
              </div>
              <div className='col-md-6'>
                <div className='form-group'>
                  <label htmlFor='time'>Preferred Time *</label>
                  <select
                    id='time'
                    name='time'
                    className='form-control'
                    value={formData.time}
                    onChange={handleChange}
                    required
                  >
                    <option value=''>Select a time</option>
                    <option value='09:00 AM'>09:00 AM - 10:00 AM</option>
                    <option value='10:00 AM'>10:00 AM - 11:00 AM</option>
                    <option value='11:00 AM'>11:00 AM - 12:00 PM</option>
                    <option value='01:00 PM'>01:00 PM - 02:00 PM</option>
                    <option value='02:00 PM'>02:00 PM - 03:00 PM</option>
                    <option value='03:00 PM'>03:00 PM - 04:00 PM</option>
                  </select>
                </div>
              </div>
            </div>
            
            <div className='form-group'>
              <label htmlFor='message'>How can we help you? *</label>
              <textarea
                id='message'
                name='message'
                className='form-control'
                rows='5'
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            
            <div className='text-center mt-4'>
              <button type='submit' className='submit-btn'>
                Schedule Call
              </button>
            </div>
          </form>
          
          <div className='mt-5 text-center'>
            <h4>Prefer to email us directly?</h4>
            <p>
              <a href='mailto:info@onexinfinity.com' className='text-primary'>info@onexinfinity.com</a>
            </p>
          </div>
        </div>
      </div>
      
      <Footer />
    </>
  );
}

export default BookACall;
